import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Button, ButtonLink } from "@/components/ui/Button";
import { Icon } from "@/components/ui/Icon";
import { Eyebrow } from "@/components/ui/Chips";
import { env } from "@/lib/env";

/**
 * Router-level boundary. Catches render errors and loader failures anywhere in
 * the tree so a single broken component never leaves a blank page.
 */
export default function RouteError() {
  const error = useRouteError();

  const status = isRouteErrorResponse(error) ? error.status : 500;
  const title = status === 404 ? "Page not found" : "Something went wrong";
  const detail =
    error instanceof Error
      ? error.message
      : isRouteErrorResponse(error)
        ? error.statusText
        : "An unexpected error occurred.";

  return (
    <>
      <Header />

      <main id="main" className="page-main">
        <section className="error-page">
          <div className="ambient" aria-hidden="true">
            <span
              className="ambient__blob ambient__blob--green"
              style={{ width: 520, height: 520, top: -220, left: -160, opacity: 0.32 }}
            />
          </div>

          <div className="container error-page__inner">
            <Eyebrow>Error {status}</Eyebrow>
            <div className="error-code">{status}</div>
            <h1 style={{ fontSize: "clamp(1.7rem,3.4vw,2.4rem)" }}>{title}</h1>
            <p className="lead mx-auto">
              This one is on us. The page failed to render — reloading usually clears it.
            </p>

            {env.isDev ? (
              <pre
                style={{
                  marginTop: 24,
                  padding: 16,
                  borderRadius: "var(--radius-md)",
                  background: "var(--surface-3)",
                  border: "1px solid var(--border)",
                  fontSize: ".78rem",
                  textAlign: "left",
                  overflowX: "auto",
                  color: "var(--danger)",
                }}
              >
                {detail}
              </pre>
            ) : null}

            <div className="error-links">
              <Button variant="primary" onClick={() => window.location.reload()}>
                <Icon name="recycle" />
                Reload the page
              </Button>
              <ButtonLink to="/" variant="ghost">
                Back to home
              </ButtonLink>
              <ButtonLink to="/contact" variant="ghost">
                Report a problem
              </ButtonLink>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
